export default [
    {  // 社区 - 模块管理
        path: 'sns_classify_list',
        name: 'm_sns_classify',
        component: () => import('@/pages/sns/classify_list')
    }, {  // 社区 - 标签管理
        path: 'sns_topic_list',
        name: 'm_sns_topic',
        component: () => import('@/pages/sns/topic_list')
    },{  // 社区内容 - 话题管理
        path: 'moments_topic',
        name: 'm_moments_topic',
        component: () => import('@/pages/moments/moments_topic')
    }, {  // 社区内容 - 话题详情
        path: 'moments_topic_detail/:id',
        name: 'moments_topic_detail',
        meta: {
            title: '话题详情'
        },
        props: route => route.params,
        component: () => import('@/pages/moments/moments_topic_detail')
    }, {  // 新建话题管理
        path: 'moments_topic_add',
        name: 'moments_topic_add',
        meta: {
            title: '新建话题'
        },
        component: () => import('@/pages/moments/moments_topic_add')
    }, {  // 编辑话题管理
        path: 'moments_topic_edit/:id',
        name: 'moments_topic_edit',
        meta: {
            title: '编辑话题'
        },
        props: route => route.params,
        component: () => import('@/pages/moments/moments_topic_edit')
    }, {  // 社区内容 - 分享管理
        path: 'moments_good_share',
        name: 'm_moments_good_share',
        component: () => import('@/pages/moments/moments_good_share')
    }, {  // 社区内容 - 话分享详情
        path: 'moments_good_share_detail/:id',
        name: 'moments_good_share_detail',
        meta: {
            title: '分享详情'
        },
        props: route => route.params,
        component: () => import('@/pages/moments/moments_good_share_detail')
    }, {  // 社区内容 - 话题跟帖管理
        path: 'moments_topic_follow',
        name: 'm_moments_topic_follow',
        meta: {
            title: '话题跟帖'
        },
        props: route => route.query,
        component: () => import('@/pages/moments/moments_topic_follow')
    }, {  // 社区内容 - 话分享详情
        path: 'moments_topic_follow_detail/:id',
        name: 'moments_topic_follow_detail',
        meta: {
            title: '分享详情'
        },
        props: route => route.params,
        component: () => import('@/pages/moments/moments_topic_follow_detail')
    }, {  // 社区内容 - 评论管理
        path: 'moments_comment',
        name: 'm_moments_comment',
        meta: {
            title: '评论管理'
        },
        props: route => route.query,
        component: () => import('@/pages/moments/moments_comment')
    }, {  // 社区内容 - 审核管理
        path: 'moments_apply',
        name: 'm_moments_apply',
        component: () => import('@/pages/moments/moments_apply')
    }, {  // 社区内容 - 审核管理详情
        path: 'moments_apply_detail/:id',
        name: 'moments_apply_detail',
        meta: {
            title: '社区内容详情'
        },
        props: route => route.params,
        component: () => import('@/pages/moments/moments_apply_detail')
    }, {  // 社区内容 - 审核管理审核
        path: 'moments_apply_verify/:id',
        name: 'moments_apply_verify',
        meta: {
            title: '社区内容审核'
        },
        props: route => route.params,
        component: () => import('@/pages/moments/moments_apply_verify')
    }
];